import { DEFAULT_AFFILIATION } from './ecommerce'
import { getAbsoluteProductURL } from './track'

const sortMapping = (value) => {
  return {
    Brand__ASC: 'Brand: A to Z',
    Brand__DESC: 'Brand: Z to A',
    CalculatedLoyaltyPoints__ASC: 'Rewards Points: Low to High',
    CalculatedLoyaltyPoints__DESC: 'Rewards Points: High to Low',
    CasePrice__ASC: 'Case Price: Low to High',
    CasePrice__DESC: 'Case Price: High to Low',
    '': 'Relevance',
  }
}

export const convertProductFilterToSegment = (filterOptions) => {
  const {
    Brand: brand,
    ContainerType: container,
    Country: country,
    Region: region,
    LiquorStyle: style,
    Varietal: varietal,
    DisplayPrice__gte: pricegte,
    DisplayPrice__lte: pricelte,
    Sort: sort,
    q: keyword,
    limit,
  } = filterOptions

  const newFilterOptions = Object.assign(
    {},
    {
      brand,
      container,
      country,
      region,
      style,
      varietal,
    }
  )

  const filterData = []
  const sortData = []

  // Type Filter
  ;['brand', 'container', 'country', 'region', 'style', 'varietal'].forEach((filterKey) => {
    const filterItem = newFilterOptions[filterKey]
    if (filterItem?.length > 0) {
      filterData.push({
        type: filterKey,
        value: filterItem.join(', '),
      })
    }
  })

  // Price Filter
  filterData.push({
    type: 'price_greater_than_equal',
    value: pricegte,
  })

  filterData.push({
    type: 'price_less_than_equal',
    value: pricelte,
  })

  // Search Filter
  if (keyword) {
    filterData.push({
      type: 'Search',
      value: keyword,
    })
  }

  // Sort
  if (sort) {
    const sortTmp = sort.split('__')

    if (sortTmp.length > 0) {
      sortData.push({
        type: sortTmp[0],
        value: sortTmp[1],
      })
    }
  }

  if (limit) {
    sortData.push({
      type: 'Display',
      value: limit,
    })
  }

  return {
    filters: filterData,
    sorts: sortData,
  }
}

export const convertProductToSegmentProduct = (product, config = {}) => {
  const { loyaltyPoints, supplierLoyaltyPoints, bonusLoyaltyPoints, sell_by_case, wholesale_unit_per_case } = product

  let calculatedLoyaltyPoints = loyaltyPoints
  if (sell_by_case) {
    calculatedLoyaltyPoints = loyaltyPoints * wholesale_unit_per_case
  }

  if (supplierLoyaltyPoints) {
    calculatedLoyaltyPoints *= supplierLoyaltyPoints
  }

  let calculatedBonusLoyaltyPoints = bonusLoyaltyPoints

  return {
    product_id: product?.productID,
    sku: product?.sku,
    category: product?.webCategory,
    name: product?.title,
    brand: product?.brand,
    country: product?.country,
    region: product?.region,
    style: product?.style,
    varietal: product?.varietal,
    sohRaw: product?.sohRaw,
    currency: 'aud',
    quantity: product?.caseQty || 0,
    url: getAbsoluteProductURL(product),
    image_url: product?.image,
    wetTax: product?.wetTax,
    variant: config?.variant,
    price: config?.price,
    position: config?.position,
    email: window.subSupplierParentEmail,
    quantity: config?.quantity,
    loyaltyPoints: calculatedLoyaltyPoints,
    bonusLoyaltyPoints: calculatedBonusLoyaltyPoints,
  }
}

export const convertProductArrayToSegmentProducts = (products) => {
  let segmentProducts = []

  products.forEach((product, key) => {
    segmentProducts.push(
      convertProductToSegmentProduct(product, {
        position: key,
        price: product?.case_price,
        variant: 'case',
        quantity: product?.caseTotal || 0,
      })
    )

    if (!product?.sell_by_case && product?.unit_price > 0) {
      segmentProducts.push(
        convertProductToSegmentProduct(product, {
          position: key,
          price: product?.unit_price,
          variant: 'unit',
          quantity: product?.unitTotal || 0,
        })
      )
    }
  })

  return segmentProducts
}

export const convertElvantiCartItemsToSegment = (cartItems) => {
  const list = []

  if (!cartItems) return list

  cartItems.forEach((cartItem, key) => {
    if (cartItem?.caseTotal > 0) {
      list.push(
        convertProductToSegmentProduct(cartItem, {
          position: key,
          price: cartItem?.case_price,
          variant: 'case',
        })
      )
    }

    if (cartItem?.unitTotal > 0) {
      list.push(
        convertProductToSegmentProduct(cartItem, {
          position: key,
          price: cartItem?.unit_price,
          variant: 'unit',
        })
      )
    }
  })

  return list
}
export const convertProductToGA4Item = (product, config = {}, index) => {
  const { loyaltyPoints, supplierLoyaltyPoints, bonusLoyaltyPoints, sell_by_case, wholesale_unit_per_case } = product

  let calculatedLoyaltyPoints = loyaltyPoints
  if (sell_by_case) {
    calculatedLoyaltyPoints = loyaltyPoints * wholesale_unit_per_case
  }

  if (supplierLoyaltyPoints) {
    calculatedLoyaltyPoints *= supplierLoyaltyPoints
  }

  let calculatedBonusLoyaltyPoints = bonusLoyaltyPoints

  return {
    item_id: product.productID,
    item_name: product.title,
    affiliation: product.supplierName || DEFAULT_AFFILIATION,
    coupon: '',
    discount: '',
    index,
    item_brand: product.brand,
    item_category: product.webCategory,
    item_category2: '',
    country: product.country,
    region: product.region,
    item_list_id: '',
    item_list_name: '',
    item_variant: config.variant,
    location_id: '',
    price: config.price,
    quantity: config.quantity,
    loyaltyPoints: calculatedLoyaltyPoints,
    email: window.subSupplierParentEmail,
    bonusLoyaltyPoints: calculatedBonusLoyaltyPoints,
  }
}

export const convertProductToGA4Payload = (products, config = {}) => {
  const payload = {
    currency: 'AUD',
    value: 0,
    items: [],
  }

  if (Array.isArray(products)) {
    products.forEach((product, index) => {
      const caseItem = convertProductToGA4Item(
        product,
        {
          price: product?.case_price,
          variant: 'case',
          quantity: product?.caseTotal,
        },
        index
      )

      if (!product?.sell_by_case && product?.unit_price > 0) {
        const unitItem = convertProductToGA4Item(
          product,
          {
            price: product?.unit_price,
            variant: 'unit',
            quantity: product?.unitTotal,
          },
          index
        )
        payload.items.push(unitItem)
        payload.value += parseInt(product.unit_price) * (product?.unitTotal || 1)
      }

      payload.items.push(caseItem)
      payload.value += parseInt(product.case_price) * (product?.caseTotal || 1)
    })
  } else {
    const item = convertProductToGA4Item(products, config, 0)
    payload.items.push(item)
    payload.value += parseInt(config.price) * (config?.quantity || 1)
  }

  if (config?.value > 0) {
    payload.value = config?.value
  }

  return payload
}

export const convertCheckoutToGA4Payload = (products, config = {}) => {
  let productPayload = convertProductToGA4Payload(products, { value: config?.value })

  const payload = {
    ...config,
    ...productPayload,
  }

  return payload
}
